import axios from 'lib/axios'

interface ResendActivationEmailRequest {
  userId: number
}

export const fetchResendActivationEmail = async ({
  userId,
}: ResendActivationEmailRequest): Promise<void> => {
  await axios.post('/user/activation-email', { userId })
}
